import base64 from '@/mixin/base64'
import changeMailsStore from '@/mixin/changeMailsStore'

export default {
  mixins: [base64, changeMailsStore],
  computed: {
    draftEmail: {
      get () {
        return this.$store.getters.draftEmail
      },
      set (data) {
        this.$store.dispatch('setDraftEmail', data)
      }
    }
  },
  methods: {
    async sendDraft ({mail, userId, draftThreadId}) {
      const boundary = 'foo_bar_baz'
      const body = {
        message: {
          raw: this.base64Encode(mail)
        }
      }
      const options = {
        path: `https://www.googleapis.com/gmail/v1/users/${userId}/drafts?uploadType=multipart`,
        method: 'POST',
        headers: {'Content-Type': `multipart/related; boundary="${boundary}"`},
        body: body
      }
      try {
        const resp = await this.$gapi.request(options)
        if (draftThreadId) this.removeDraftThread({userId, threadId: draftThreadId})
        return resp.result
      } catch (err) {
        console.error(err)
        return {}
      }
    },
    removeDraftThread ({userId, threadId}) {
      this.$gapi.request({
        path: `https://gmail.googleapis.com/gmail/v1/users/${userId}/threads/${threadId}`,
        method: 'DELETE'
      })
        .then(() => {
          this.spliceThread(threadId, this.draftEmail)
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/sendDraft.js